import { render, staticRenderFns } from "./SessionEdit.vue?vue&type=template&id=b0ff0302&"
import script from "./SessionEdit.vue?vue&type=script&lang=js&"
export * from "./SessionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports